import { ValidationResult } from "nutso";
import * as React from "react";
import { Button } from "../elements/Button";
import { ButtonType } from "../elements/ButtonType";
import { toastStore } from "../utils/toastStore";
//import "../scss/_form.scss"

export type FormButton = {
  label: string;
  handler: () => void;
};

/**
 * Form is of 3 types,
 *
 * 1. the default type, that is just flows vertical including the labels and input (optimised for mobile first)
 * 2. horizontal - default on mobile and flows side ways on tablet
 * 3. responsive - default on mobile and the label and the input is horizontal on tablet
 */
type Props = {
  additionalClassNames?: string;
  validationResult: ValidationResult;
  submit?: FormButton;
  cancel?: FormButton;
  loading?: boolean;
  type: "default" | "responsive" | "horizontal";
  dataCy?: string;
  children: React.ReactNode;
};

export const Form = (props: Props) => {
  //
  const renderCancel = () => {
    const { cancel } = props;
    if (!cancel) return null;
    return (
      <Button onClick={cancel.handler} className="cancel-button">
        {cancel.label}
      </Button>
    );
  };

  const renderSubmit = () => {
    const { submit, validationResult } = props;
    if (!submit) return null;
    return (
      <Button
        disabled={!validationResult.isValid}
        className="submit-button"
        type={ButtonType.primary}
        onClick={() => {
          if (!validationResult.isValid) {
            toastStore.error(`[${validationResult.errorPath.join(".")}] ${validationResult.errorMessage}`);
            return;
          }
          submit.handler();
        }}
        dataCy="submit"
      >
        {submit.label}
      </Button>
    );
  };

  const renderButtons = () => {
    const { submit, cancel } = props;
    if (!submit && !cancel) return null;

    return (
      <div className="form-buttons">
        {renderSubmit()}
        {renderCancel()}
      </div>
    );
  };

  return (
    <div className={`form ${props.type} ${props.additionalClassNames}`} data-cy={props.dataCy}>
      <div className="form-items">{props.children}</div>
      {renderButtons()}
    </div>
  );
};
